enum Visibility: Public, Private
enum string ItemType: None, All, Media, Target, Package, Image, Night, Day, Water, Sewage, People, Gasoline, Service, Bad
	
Item
	string id = string.undefined
	ItemType type
	string[] images
	string text
	string origin
	float x, y
	int rating
	string userId
	PlainTimeString date
	bool active = true
	SpeedTest[] speedTests
	float heading, pitch
	
	// Fuel
	float fuelPrice
	
	// Media
	string[] media
	string thumbnail
	
	// Tags
	string street
	string city
	string country
	string region
	string state
	string tags
	int population

	// Information
	string services
	string price
	
	// Dynamic
	float spreadX, spreadY
	float mapX, mapY
	string key
	int index
	int indexWithinGroup
	
User
	string id
	string username
	
SpeedTest
	PlainTimeString date
	string providerName
	float speed
	
enum WeatherMode: Today, NextFiveDays
		
SpeedTestFile
	string url
	int size
	
